import React from 'react';
import TransactionsList from './TransactionsList';

const OutTransactions: React.FC = () => (
  <TransactionsList
    type="out"
    title="Out Transactions"
    description="All outgoing transactions with search, currency and date filters"
  />
);

export default OutTransactions;
